import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/mag/legacy-logo-gray.png'
import _imports_1 from '../../assets/images/primaveras/Primaveras-Logo-horizontal.png'
import _imports_2 from '../../assets/images/mag/logo-mag.png'


const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = {
  key: 1,
  class: "sidebar-logo"
}
const _hoisted_3 = {
  key: 0,
  id: "legacy-gray",
  alt: "legacy-logo",
  class: "sidebar-legacy-logo",
  fetchpriority: "high",
  src: _imports_0
}
const _hoisted_4 = {
  key: 0,
  class: "header-brand",
  href: "https://legacyfuneral.com.br"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  id: "logo-mag",
  alt: "mag-seguros-logo",
  class: "mx-auto sidebar-legacy-logo mag-logo",
  fetchpriority: "high",
  src: _imports_2
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "item-sidebar phone",
  role: "button"
}
const _hoisted_9 = {
  class: "item-sidebar",
  href: "https://www.primaveras.com.br/onde/",
  role: "button"
}
const _hoisted_10 = {
  class: "item-sidebar",
  href: "https://api.whatsapp.com/send?phone=551124048900",
  role: "button",
  target: "_blank"
}
const _hoisted_11 = {
  class: "item-sidebar",
  href: "https://www.primaveras.com.br/fale-conosco/",
  role: "button"
}
const _hoisted_12 = {
  key: 3,
  class: "header-right"
}
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = {
  key: 4,
  class: "sidebar-button"
}
const _hoisted_15 = { class: "sidebar-body" }
const _hoisted_16 = { class: "sidebar-item cursor-pointer" }
const _hoisted_17 = { class: "item-name" }
const _hoisted_18 = { class: "sidebar-item cursor-pointer" }
const _hoisted_19 = { class: "item-name" }
const _hoisted_20 = { class: "sidebar-item cursor-pointer" }
const _hoisted_21 = { class: "item-name" }
const _hoisted_22 = { class: "sidebar-item cursor-pointer" }
const _hoisted_23 = { class: "item-name" }
const _hoisted_24 = { class: "field-wrapper cpf-wrapper" }
const _hoisted_25 = { class: "legacy-white-button legacy-text-button" }
const _hoisted_26 = { class: "field-wrapper password-wrapper" }
const _hoisted_27 = { class: "password-field" }
const _hoisted_28 = { class: "legacy-white-button legacy-text-button password-input" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "mt-3" }
const _hoisted_31 = { class: "button-content" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "text-alert mt-2" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "field-wrapper cpf-wrapper" }
const _hoisted_38 = {
  key: 0,
  class: "legacy-white-button legacy-text-button"
}
const _hoisted_39 = {
  key: 2,
  class: "text-alert"
}
const _hoisted_40 = {
  key: 3,
  class: "text-alert"
}
const _hoisted_41 = { key: 4 }

export function render(_ctx, _cache) {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_legacy_icon = _resolveComponent("legacy-icon")
  const _component_MaskedInput = _resolveComponent("MaskedInput")
  const _component_Modal = _resolveComponent("Modal")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{'primaveras': this.$store.getters.getStyleMode === 'primaveras', 'mag-seguros': this.$store.getters.getStyleMode === 'mag-seguros', 'legacy': this.$store.getters.getStyleMode === 'legacy'}, "d-flex justify-content-between header-wrapper"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (this.$store.getters.getStyleMode === 'legacy')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.notMainRoot)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "back-button",
                    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.back()))
                  }, [
                    _createVNode(_component_fa_icon, {
                      icon: ['fa', 'chevron-left'],
                      class: "back-icon"
                    }),
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "VOLTAR", -1))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (this.$store.getters.getStyleMode === 'mag-seguros')
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[18] || (_cache[18] = _createElementVNode("img", {
                      id: "primaveras-logo",
                      alt: "primaveras-logo",
                      class: "sidebar-legacy-logo",
                      decoding: "async",
                      fetchpriority: "high",
                      height: "449",
                      sizes: "(max-width: 2814px) 100vw, 2814px",
                      src: _imports_1,
                      width: "2814"
                    }, null, -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "by", -1)),
                    _createVNode(_component_legacy_icon, {
                      isSvg: true,
                      class: "sidebar-legacy-logo second-logo",
                      icon: "legacy-logo-2"
                    })
                  ], 64))
            ]))
      ]),
      (this.$store.getters.getStyleMode === 'legacy')
        ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
            _createElementVNode("img", {
              src: require('@/assets/svg/logo_brand.svg'),
              alt: "Legacy Funeral",
              class: "header-logo"
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.getStyleMode === 'mag-seguros')
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (this.$store.getters.getStyleMode !== 'legacy')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([{'show': _ctx.sidebarPrimaverasVisible}, "sidebar-right"])
          }, [
            (this.$store.getters.getStyleMode === 'mag-seguros')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[20] || (_cache[20] = [
                  _createTextVNode("Ambiente exclusivo para atendimentos "),
                  _createElementVNode("br", null, null, -1),
                  _createTextVNode(" da "),
                  _createElementVNode("strong", null, "MAG SEGUROS", -1)
                ])))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("a", _hoisted_8, [
                    _createVNode(_component_legacy_icon, {
                      id: "phone",
                      isSvg: true,
                      alt: "phone icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/phone-24h"
                    }),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "phone-tooltip" }, [
                      _createElementVNode("a", { href: "tel:+551124048900" }, "(11) 2404-8900 • (11) 2402-6400")
                    ], -1))
                  ]),
                  _createElementVNode("a", _hoisted_9, [
                    _createVNode(_component_legacy_icon, {
                      id: "pin",
                      isSvg: true,
                      alt: "location pin icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/location"
                    })
                  ]),
                  _createElementVNode("a", _hoisted_10, [
                    _createVNode(_component_legacy_icon, {
                      id: "whats",
                      isSvg: true,
                      alt: "whatsapp icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/whatsapp"
                    })
                  ]),
                  _createElementVNode("a", _hoisted_11, [
                    _createVNode(_component_legacy_icon, {
                      id: "mail",
                      isSvg: true,
                      alt: "email icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/mail-icon"
                    })
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("a", { class: "item-sidebar last" }, null, -1))
                ], 64))
          ], 2))
        : _createCommentVNode("", true),
      (this.$store.getters.getStyleMode === 'legacy')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: _normalizeClass(["hamburger-btn", {'is-open': _ctx.sidebarVisible}]),
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.openCloseSidebar())),
              "aria-expanded": _ctx.sidebarVisible.toString(),
              "aria-label": "Abrir menu"
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("span", null, null, -1),
              _createElementVNode("span", null, null, -1),
              _createElementVNode("span", null, null, -1)
            ]), 10, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.getStyleMode !== 'legacy')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (this.$store.getters.getStyleMode !== 'primaveras')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.sidebarVisible)
                    ? (_openBlock(), _createBlock(_component_legacy_icon, {
                        key: 0,
                        class: "times sidebar-menu-icon",
                        icon: "times",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.openCloseSidebar()))
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.sidebarVisible)
                    ? (_openBlock(), _createBlock(_component_legacy_icon, {
                        key: 1,
                        class: "sidebar-menu-icon",
                        icon: "bars",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.openCloseSidebar()))
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_component_legacy_icon, {
                  key: 1,
                  class: "times sidebar-menu-icon",
                  icon: "bars",
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.sidebarPrimaverasVisible = !_ctx.sidebarPrimaverasVisible))
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{'visible': _ctx.sidebarVisible, 'primaveras': this.$store.getters.getStyleMode === 'primaveras'}, "sidebar"])
    }, [
      _createElementVNode("div", _hoisted_15, [
        (this.$store.getters.getStyleMode !== 'primaveras')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[24] || (_cache[24] = _createStaticVNode("<a class=\"nav-mobile-item\" href=\"https://legacyfuneral.com.br\" data-v-713eccf0>HOME</a><a class=\"nav-mobile-item\" href=\"https://legacyfuneral.com.br/sobre.html\" data-v-713eccf0>SOBRE</a><a class=\"nav-mobile-item\" href=\"https://legacyfuneral.com.br/parceiro.html\" data-v-713eccf0>PARCEIRO</a><a class=\"nav-mobile-item\" href=\"https://loja.legacyfuneral.com.br/plano/fornecedor?cKey=P.legacy\" data-v-713eccf0>PLANO FUNERÁRIO</a><a class=\"nav-mobile-item\" href=\"https://loja.legacyfuneral.com.br/imediato/fornecedor?cKey=P.legacy\" data-v-713eccf0>FUNERAL IMEDIATO</a>", 5))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", null, [
                    _createVNode(_component_legacy_icon, {
                      isSvg: true,
                      alt: "phone icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/phone-24h"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("a", null, [
                    _createVNode(_component_legacy_icon, {
                      isSvg: true,
                      alt: "location pin icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/location"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", null, [
                    _createVNode(_component_legacy_icon, {
                      isSvg: true,
                      alt: "whatsapp icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/whatsapp"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", null, [
                    _createVNode(_component_legacy_icon, {
                      isSvg: true,
                      alt: "email icon",
                      class: "sidebar-right-icon",
                      icon: "primaveras/mail-icon"
                    })
                  ])
                ])
              ])
            ], 64))
      ])
    ], 2),
    _createVNode(_component_Modal, {
      show: _ctx.loginModalVisible,
      "onUpdate:show": _cache[12] || (_cache[12] = $event => ((_ctx.loginModalVisible) = $event)),
      goldenTitle: false,
      modalClasses: 'modal-md login-modal',
      title: 'Login'
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (!_ctx.showSupplierLoginModal)
              ? _withDirectives((_openBlock(), _createBlock(_component_MaskedInput, {
                  key: 0,
                  modelValue: _ctx.login.cpf,
                  class: "button-content",
                  placeholder: "CPF/CNPJ",
                  onKeyup: _cache[5] || (_cache[5] = $event => (_ctx.clearFailMessage())),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.checkCpf($event)))
                }, null, 8, ["modelValue"])), [
                  [_directive_maska, _ctx.cpfCnpjMask]
                ])
              : _createCommentVNode("", true),
            (_ctx.showSupplierLoginModal)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.login.email) = $event)),
                  class: "button-content",
                  placeholder: "E-mail",
                  type: "email",
                  onKeyup: _cache[8] || (_cache[8] = $event => (_ctx.clearFailMessage()))
                }, null, 544)), [
                  [_vModelText, _ctx.login.email]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.login.password) = $event)),
                placeholder: _ctx.$t('password'),
                class: "button-content",
                type: "password"
              }, null, 8, _hoisted_29), [
                [_vModelText, _ctx.login.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("a", {
                class: "forgot-password-link",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.onClickForgotPassword()))
              }, "Esqueceu sua senha?")
            ]),
            _createElementVNode("div", {
              class: "legacy-primary-button legacy-text-button enter-button",
              style: {"cursor":"pointer"},
              onClick: _cache[11] || (_cache[11] = $event => (_ctx.doLogin()))
            }, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('enter')), 1)
            ])
          ]),
          (_ctx.failLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  (_ctx.checkCpfStatus && _ctx.checkCpfStatus !== true)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t("login.not_active", {email: _ctx.checkCpfStatus})), 1))
                    : _createCommentVNode("", true),
                  (_ctx.loginInvalid)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_ctx.$t("login.invalid")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.checkCpfStatus === false)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.$t("login.not_found")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_Modal, {
      show: _ctx.showResetPasswordModal,
      "onUpdate:show": _cache[15] || (_cache[15] = $event => ((_ctx.showResetPasswordModal) = $event)),
      goldenTitle: false,
      modalClasses: 'modal-md login-modal',
      title: 'Esqueceu sua senha?',
      onOnClose: _cache[16] || (_cache[16] = $event => (_ctx.closeResetPasswordModal()))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          (_ctx.resetPasswordResponse === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.login.email) = $event)),
                  class: "button-content",
                  placeholder: "Ex: joao@gmail.com",
                  type: "email"
                }, null, 512), [
                  [_vModelText, _ctx.login.email]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.resetPasswordResponse === null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "legacy-primary-button legacy-text-button enter-button",
                onClick: _cache[14] || (_cache[14] = $event => (_ctx.resetPassword()))
              }, _cache[25] || (_cache[25] = [
                _createElementVNode("div", { class: "button-content" }, "Solicitar nova senha", -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.login.email && !_ctx.isEmailValid)
            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Email inválido."))
            : _createCommentVNode("", true),
          (_ctx.resetPasswordResponse === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Não foi possível solicitar alteração de senha."))
            : _createCommentVNode("", true),
          (_ctx.resetPasswordResponse)
            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Verifique seu e-mail para detalhes sobre a criação de uma nova senha."))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}